import dayjs from "dayjs";
import { useDatetime } from "../../../../../utils/useDatetime";
import { useFhirData } from "../../../../../utils/useFhirData";
import { DiagnosisActions } from "./DiagnosisActions";
import { useSessionContext } from "../../../../../contexts/SessionContext";
import { EhrMobileGenericSection } from "../../mobile/EhrMobileGenericSection";

export function Diagnosis({
  data,
  title,
  openVisualizer,
  verifyVisualizer,
}: any) {
  const { formatToDDMMYYYY } = useDatetime;
  const { access } = useSessionContext();

  const columns = [
    { column: "Descrição", rowName: "description" },
    { column: "CID10", rowName: "param" },
    { column: "Profissional", rowName: "practitioner" },
    { column: "Informante", rowName: "informant" },
    { column: "Data", rowName: "date" },
  ];

  const rowData = data?.map((el: any) => ({
    encounterId: el?.resource?.encounter?.reference?.split("/")?.[1],
    param: el?.resource?.code?.coding?.[0]?.code,
    description: el?.resource?.code?.coding?.[0]?.display || "",
    date: formatToDDMMYYYY(dayjs(el?.resource?.recordedDate)),
    practitioner: useFhirData.findParticipant(
      el?.resource?.participant,
      "Practitioner"
    )?.display,
    informant: useFhirData.findParticipant(el?.resource?.participant, "Patient")
      ? "Paciente"
      : "Profissional",
  }));

  return (
    <EhrMobileGenericSection
      title={title}
      columns={columns}
      rows={rowData ?? []}
      actions={
        access?.type === "patient"
          ? undefined
          : (rowData: any) => (
              <DiagnosisActions
                row={rowData}
                openVisualizer={openVisualizer}
                verifyVisualizer={verifyVisualizer}
              />
            )
      }
    />
  );
}
